import React from 'react';

export default class TextBox extends React.Component {
  static defaultProps = {
    className: 'w-100 form-control form-control-sm',
    fieldName: 'defaultFieldname',
    onChange: () => {},
    placeholder: 'Default Placeholder',
    value: null,
    numberOfRows: 8,
    readOnly: false,
    autoFocus: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <textarea
        className={this.props.className}
        rows={this.props.numberOfRows}
        placeholder={this.props.placeholder}
        value={this.props.value === null ? '' : this.props.value}
        onChange={(e) => this.props.onChange(e.target.value)}
        id={`htmlidfor${this.props.fieldName}`}
        readOnly={this.props.readOnly}
        autoFocus={this.props.autoFocus}
        autoComplete='off'
      />
    );
  }
}
